export const SIZE_COLUMN = 6;
export const SERVIDUMBRE = {
  CONVENCIONAL: 'Servidumbre Convencional',
  JUDICIAL: 'Servidumbre Judicial',
  ADMINISTRATIVA: 'Servidumbre Administriva u Otra',
}
export const PROJECTS = {
  CONCESSIONS: 'Listado de Concesiones / Plantas',
}
